import React from 'react'
import { GiftCategoryList } from './list/page'
export const CategoriesPage = () => {
  return <GiftCategoryList />
}
